import React, { useContext, useEffect } from "react";
import { AuthContext } from "./AuthProviderWrapper";
import { Spin } from "antd";

/**
 * Guard pour les routes publiques réservées aux utilisateurs non connectés (signup, reset-password).
 * Si un utilisateur avec un JWT valide tente d'y accéder, il est déconnecté silencieusement.
 */
const IsPublicOnly = ({ children }) => {
  const { isLoggedIn, isLoading, logOutUser } = useContext(AuthContext);

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      logOutUser();
    }
  }, [isLoading, isLoggedIn]);

  if (isLoading || isLoggedIn) {
    return <Spin spinning={true} fullscreen />;
  }

  return children;
};

export default IsPublicOnly;
